import type * as React from "react";
import Icon from "../Icon/Icon";
import { TrashIcon } from "@heroicons/react/outline";
import { FloatingTooltip } from "../Tooltip/FloatingTooltip";

interface IUserCrudButtonsProps {
  onClickEdit: () => void;
  editTooltip?: string;
  editDisabled?: boolean;
  editDisabledTooltip?: string;
  onClickDelete: () => void;
  deleteTooltip?: string;
  deleteDisabled?: boolean;
  deleteDisabledTooltip?: string;
}

export const UserCrudButtons: React.FC<IUserCrudButtonsProps> = ({
  onClickEdit,
  editTooltip = "",
  editDisabled = false,
  editDisabledTooltip = "",
  onClickDelete,
  deleteTooltip = "",
  deleteDisabled = false,
  deleteDisabledTooltip = "",
}: IUserCrudButtonsProps) => {
  const editLabel = editDisabled && editDisabledTooltip ? editDisabledTooltip : editTooltip;
  const deleteLabel =
    deleteDisabled && deleteDisabledTooltip ? deleteDisabledTooltip : deleteTooltip;
  return (
    <div className="w-20">
      <FloatingTooltip
        content={editLabel}
        ariaHidden
        wrap
        wrapperClassName={editDisabled ? "cursor-not-allowed" : ""}
      >
        <button
          type="button"
          data-testid="user-edit-button"
          aria-label={editLabel || undefined}
          onClick={(e) => {
            e.stopPropagation();
            onClickEdit();
          }}
          disabled={editDisabled}
        >
          <Icon
            icon={"PencilAltIcon"}
            className={`w-6 h-6 mr-2 ${
              editDisabled ? "stroke-gray-400 cursor-not-allowed" : "stroke-green-500"
            }`}
          />
        </button>
      </FloatingTooltip>
      <FloatingTooltip
        content={deleteLabel}
        ariaHidden
        wrap
        wrapperClassName={deleteDisabled ? "cursor-not-allowed" : ""}
      >
        <button
          type="button"
          data-testid="user-delete-button"
          aria-label={deleteLabel || undefined}
          onClick={(e) => {
            e.stopPropagation();
            onClickDelete();
          }}
          disabled={deleteDisabled}
          className={`${deleteDisabled ? "cursor-not-allowed" : "cursor-pointer"}`}
        >
          <TrashIcon
            className={`w-6 h-6 mr-3 ${deleteDisabled ? "stroke-gray-500" : "stroke-red-500"}`}
          />
        </button>
      </FloatingTooltip>
    </div>
  );
};
